import { render, staticRenderFns } from "./basicClassModel.vue?vue&type=template&id=deadc3e8&scoped=true&"
import script from "./basicClassModel.vue?vue&type=script&lang=js&"
export * from "./basicClassModel.vue?vue&type=script&lang=js&"
import style0 from "./basicClassModel.vue?vue&type=style&index=0&id=deadc3e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deadc3e8",
  null
  
)

export default component.exports